// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

/* ── Focus ring — the first line of the design system's own stylesheet ────────
   For two years there was no :focus rule anywhere, and 38 inline \`outline:none\`
   suppressions with nothing to replace them, so keyboard focus was invisible.
   This gives every focusable control a visible ring, keyed to the active
   scheme's highlight colour (published to --gwv-focus from the theme).

   :focus-visible, so it appears for keyboard users and not on mouse click.
   Controls that still inline-set \`outline:none\` override this until they move
   onto the shared primitives — but every button, link and native control that
   does NOT override now shows focus immediately. */
:root { --gwv-focus: #4a90d9; }

:focus-visible {
  outline: 2px solid var(--gwv-focus);
  outline-offset: 2px;
  border-radius: 3px;
}

/* Placeholders shipped at the browser default (~0.54 of the text colour), which
   read as too faint on the darker input surfaces. Lift them a little so they are
   legible on both grounds while still clearly reading as placeholder text. */
input::placeholder,
textarea::placeholder {
  opacity: 0.72;
}

/* Respect users who ask for less motion — belt to the app's inline transitions. */
@media (prefers-reduced-motion: reduce) {
  *, *::before, *::after {
    animation-duration: 0.001ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.001ms !important;
    scroll-behavior: auto !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;AAEA;;;;;;;;;mDASmD;AACnD,QAAQ,oBAAoB,EAAE;;AAE9B;EACE,mCAAmC;EACnC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;6EAE6E;AAC7E;;EAEE,aAAa;AACf;;AAEA,kFAAkF;AAClF;EACE;IACE,sCAAsC;IACtC,uCAAuC;IACvC,uCAAuC;IACvC,gCAAgC;EAClC;AACF","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n/* ── Focus ring — the first line of the design system's own stylesheet ────────\n   For two years there was no :focus rule anywhere, and 38 inline `outline:none`\n   suppressions with nothing to replace them, so keyboard focus was invisible.\n   This gives every focusable control a visible ring, keyed to the active\n   scheme's highlight colour (published to --gwv-focus from the theme).\n\n   :focus-visible, so it appears for keyboard users and not on mouse click.\n   Controls that still inline-set `outline:none` override this until they move\n   onto the shared primitives — but every button, link and native control that\n   does NOT override now shows focus immediately. */\n:root { --gwv-focus: #4a90d9; }\n\n:focus-visible {\n  outline: 2px solid var(--gwv-focus);\n  outline-offset: 2px;\n  border-radius: 3px;\n}\n\n/* Placeholders shipped at the browser default (~0.54 of the text colour), which\n   read as too faint on the darker input surfaces. Lift them a little so they are\n   legible on both grounds while still clearly reading as placeholder text. */\ninput::placeholder,\ntextarea::placeholder {\n  opacity: 0.72;\n}\n\n/* Respect users who ask for less motion — belt to the app's inline transitions. */\n@media (prefers-reduced-motion: reduce) {\n  *, *::before, *::after {\n    animation-duration: 0.001ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.001ms !important;\n    scroll-behavior: auto !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
